import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCheckFailedSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 134,
	height: 91,
	viewBox: "0 0 134 91",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 49.2329C-1.79105e-05 57.2388 6.75793 76.3581 21.3762 84.7678C36.3025 93.3547 48.8168 86.17 66.419 86.4533C79.714 86.6672 87.9068 90.4652 100.468 86.4533C118.242 80.7767 137.525 71.0444 133.449 54.1488C130.614 42.399 117.113 42.5897 108.713 33.3615C100.334 24.1558 101.233 14.6517 90.8489 7.37749C68.3714 -8.36875 40.9582 3.42952 20.002 20.8611C9.35388 29.7184 1.79105e-05 41.2269 0 49.2329Z",
			fill: "#FFF2F5",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 70,
			cy: 23,
			r: 15,
			stroke: "#F29FB2",
			strokeWidth: .434256,
			strokeLinecap: "round",
			strokeDasharray: "1.74 2.61"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24.5,
			cy: 24.5,
			r: 24.5,
			transform: "matrix(-1 0 0 1 62 31)",
			stroke: "#F29FB2",
			strokeWidth: .434256,
			strokeLinecap: "round",
			strokeDasharray: "1.74 2.61"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 104,
			cy: 59,
			r: 10,
			stroke: "#F2A2B5",
			strokeWidth: .434256,
			strokeLinecap: "round",
			strokeDasharray: "1.74 2.61"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 40.7328,
			y: 18.5999,
			width: 4.5621,
			height: .906486,
			transform: "rotate(-45 40.7328 18.5999)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 97.4989,
			y: 34.4827,
			width: 4.5621,
			height: .906486,
			transform: "rotate(-45 97.4989 34.4827)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 47.7919,
			y: 82.1309,
			width: 4.5621,
			height: .906486,
			transform: "rotate(-45 47.7919 82.1309)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 119.558,
			y: 68.8953,
			width: 4.5621,
			height: .906486,
			transform: "rotate(-45 119.558 68.8953)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 41.3381,
			y: 15.2947,
			width: 4.71793,
			height: .970329,
			transform: "rotate(45 41.3381 15.2947)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98.1042,
			y: 31.1772,
			width: 4.71793,
			height: .970329,
			transform: "rotate(45 98.1042 31.1772)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 48.3972,
			y: 78.8254,
			width: 4.71793,
			height: .970329,
			transform: "rotate(45 48.3972 78.8254)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 120.164,
			y: 65.5898,
			width: 4.71793,
			height: .970329,
			transform: "rotate(45 120.164 65.5898)",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5342 20C33.6456 20 35.358 21.7119 35.3584 23.8232L35.3535 24.0205C35.2511 26.0407 33.5799 27.6474 31.5342 27.6475L31.3379 27.6426C29.3176 27.5402 27.7109 25.869 27.7109 23.8232C27.7114 21.712 29.4229 20.0002 31.5342 20ZM30.209 25.9326C30.5932 26.1748 31.0465 26.3173 31.5342 26.3174C32.9114 26.3174 34.0283 25.2004 34.0283 23.8232C34.0282 23.3357 33.8857 22.8822 33.6436 22.498L30.209 25.9326ZM31.5342 21.3301C30.1574 21.3303 29.0414 22.4465 29.041 23.8232C29.041 24.335 29.1955 24.8111 29.46 25.207L32.918 21.749C32.522 21.4845 32.046 21.3301 31.5342 21.3301Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.418 73.2373C99.5295 73.2374 101.242 74.9491 101.242 77.0605L101.237 77.2578C101.135 79.2778 99.4634 80.8846 97.418 80.8848L97.2217 80.8799C95.2015 80.7775 93.595 79.1061 93.5947 77.0605C93.5949 74.9491 95.3065 73.2375 97.418 73.2373ZM96.0928 79.1699C96.4769 79.4119 96.9305 79.5546 97.418 79.5547C98.7949 79.5546 99.9119 78.4375 99.9121 77.0605C99.912 76.5731 99.7693 76.1195 99.5273 75.7354L96.0928 79.1699ZM97.418 74.5674C96.0411 74.5676 94.925 75.6837 94.9248 77.0605C94.9249 77.5722 95.0794 78.0475 95.3438 78.4434L98.8008 74.9863C98.4049 74.7219 97.9297 74.5674 97.418 74.5674Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M88.1211 19.4238C88.0604 19.2114 88.2199 19 88.4408 19H91.5592C91.7801 19 91.9396 19.2114 91.8789 19.4238L90.3197 24.881C90.2278 25.2026 89.7722 25.2026 89.6803 24.881L88.1211 19.4238Z",
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 90,
			cy: 26.5,
			rx: 1,
			ry: .5,
			fill: "#F39DB2"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_ddddd_5649_532)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 22.7104,
				y: 47.8862,
				width: 36.8771,
				height: 23.2908,
				rx: 2.66,
				transform: "rotate(-8.69553 22.7104 47.8862)",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.9731 49.6033C22.828 48.655 23.4792 47.7687 24.4275 47.6236L57.4467 42.5736C58.395 42.4286 59.2813 43.0798 59.4263 44.0281L59.9707 47.5871L23.5174 53.1624L22.9731 49.6033Z",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 44.4808,
			y1: 60.7505,
			x2: 57.5825,
			y2: 58.7468,
			stroke: "#EF476F",
			strokeWidth: 1.30277,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 43.9185,
			y1: 57.0735,
			x2: 57.0201,
			y2: 55.0698,
			stroke: "#EF476F",
			strokeWidth: 1.30277,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 43.3561,
			y1: 53.3961,
			x2: 56.4577,
			y2: 51.3923,
			stroke: "#EF476F",
			strokeWidth: 1.30277,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 45.0432,
			y1: 64.4278,
			x2: 55.7466,
			y2: 62.7908,
			stroke: "#EF476F",
			strokeWidth: 1.30277,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 25.6878,
			y1: 50.2078,
			x2: 34.9522,
			y2: 48.7909,
			stroke: "white",
			strokeWidth: 1.30277,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 26.1093,
			y: 55.363,
			width: 13.1011,
			height: 13.1011,
			rx: .9975,
			transform: "rotate(-8.69553 26.1093 55.363)",
			fill: "#FFCAD7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.9561 63.8833C35.5583 63.5813 35.0711 63.2204 34.9317 62.3094C34.8481 61.7627 35.2267 61.3422 35.3025 60.8511C35.3784 60.36 35.3789 59.7922 35.3881 59.3778C35.3973 58.9635 35.4016 58.8031 35.3744 58.3672C35.3395 57.8234 34.7848 56.4906 32.9513 56.771C31.1185 57.0513 30.9863 58.4892 31.1166 59.0184C31.221 59.4425 31.2732 59.5942 31.4057 59.9869C31.5382 60.3796 31.7075 60.9214 31.9266 61.3674C32.1457 61.8134 32.6332 62.1014 32.7168 62.6481C32.8562 63.5591 32.499 64.0491 31.2554 64.7552C30.0072 65.4631 29.2229 66.0928 29.2768 66.4447L29.5289 68.0935L39.6015 66.553L39.3494 64.9042C39.2956 64.5528 38.3584 64.1864 36.9561 63.8833Z",
			fill: "#FF92AC"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter1_d_5649_532)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					filter: "url(#filter2_ddddd_5649_532)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M78.9516 50.2746C78.6487 52.7856 76.3681 54.5758 73.8571 54.2733L44.1301 50.6912C41.6191 50.3887 39.8289 48.1081 40.1314 45.5971L41.9853 30.2089C42.2882 27.6979 44.5689 25.9077 47.0799 26.2106L76.8069 29.7923C79.3179 30.0944 81.1081 32.3755 80.8056 34.8864L78.9516 50.2746Z",
						fill: "#F5C0CD"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.8269 46.2292L52.0938 43.49L52.1365 43.1405L74.8689 45.8793L74.8269 46.2292Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.5737 48.3284L51.8409 45.5891L51.8833 45.2397L74.6161 47.9785L74.5737 48.3284Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.2055 46.5702L52.383 46.9238C52.4296 47.0157 52.4673 47.1001 52.5076 47.1911L52.5168 47.1919C52.5785 47.1068 52.6377 47.0342 52.6985 46.9587L52.9515 46.6599L53.251 46.6964L52.6423 47.3702L53.0828 48.2219L52.7677 48.1842L52.5856 47.8141C52.5366 47.7185 52.4963 47.6278 52.4539 47.5297L52.4472 47.5288C52.3859 47.614 52.3226 47.6899 52.255 47.7738L51.9932 48.0906L51.6882 48.0541L52.323 47.3413L51.8967 46.5328L52.2055 46.5702Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M53.6624 46.7462L53.8403 47.0999C53.8869 47.1918 53.9242 47.2761 53.9645 47.3667L53.9737 47.368C54.0354 47.2828 54.095 47.2098 54.1554 47.1347L54.4084 46.836L54.708 46.8721L54.0992 47.5463L54.5401 48.3979L54.2251 48.3598L54.0426 47.9897C53.9939 47.8941 53.9532 47.8035 53.9112 47.7053L53.9045 47.7049C53.8433 47.79 53.7795 47.8655 53.7124 47.9495L53.4506 48.2666L53.1451 48.2297L53.7799 47.5173L53.3541 46.7089L53.6624 46.7462Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.1198 46.9216L55.2977 47.2757C55.3442 47.3671 55.382 47.4519 55.4223 47.5421L55.4315 47.5437C55.4932 47.4582 55.5528 47.3852 55.6132 47.3105L55.8662 47.0118L56.1653 47.0478L55.557 47.7216L55.9975 48.5737L55.6824 48.5356L55.5003 48.1655C55.4512 48.0699 55.411 47.9792 55.3686 47.8811L55.3619 47.8806C55.3006 47.9654 55.2373 48.0413 55.1697 48.1252L54.9079 48.442L54.6029 48.4051L55.2377 47.6927L54.8114 46.8842L55.1198 46.9216Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M56.5774 47.0973L56.7548 47.451C56.8018 47.5429 56.8392 47.6272 56.8794 47.7178L56.8887 47.7191C56.9503 47.6344 57.0099 47.5614 57.0703 47.4858L57.3233 47.1871L57.6229 47.2232L57.0145 47.8974L57.4551 48.7495L57.14 48.7113L56.9575 48.3409C56.9084 48.2456 56.8685 48.1546 56.8257 48.0568L56.8194 48.056C56.7582 48.1412 56.6948 48.2167 56.6269 48.301L56.3655 48.6178L56.0601 48.5809L56.6948 47.8685L56.269 47.06L56.5774 47.0973Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.0346 47.2724L58.2125 47.6261C58.2591 47.7179 58.2964 47.8023 58.3367 47.8933L58.3459 47.8946C58.4076 47.8094 58.4676 47.7364 58.5276 47.6613L58.781 47.3626L59.0801 47.3982L58.4718 48.0725L58.9123 48.9246L58.5977 48.8868L58.4152 48.5163C58.3661 48.4207 58.3262 48.3301 58.2834 48.2323L58.2767 48.2315C58.2159 48.3162 58.1521 48.3917 58.0846 48.4765L57.8228 48.7928L57.5173 48.7559L58.1525 48.0439L57.7263 47.235L58.0346 47.2724Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59.4917 47.4483L59.6696 47.802C59.7158 47.8939 59.754 47.9782 59.7942 48.0693L59.8035 48.0701C59.8651 47.9854 59.9243 47.9124 59.9851 47.8368L60.2381 47.5381L60.5372 47.5742L59.9285 48.248L60.369 49.1001L60.0543 49.0623L59.8723 48.6919C59.8232 48.5966 59.7829 48.5056 59.7405 48.4078L59.7338 48.407C59.6726 48.4922 59.6092 48.5677 59.5417 48.652L59.2799 48.9688L58.9749 48.9319L59.6096 48.2199L59.1834 47.411L59.4917 47.4483Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M61.3751 48.2541L61.3504 48.458L60.5725 48.3649L60.5973 48.1597L61.3751 48.2541Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M61.8969 47.738L62.0748 48.0916C62.1214 48.1835 62.1587 48.2678 62.199 48.3589L62.2082 48.3597C62.2699 48.275 62.3299 48.202 62.3899 48.1269L62.6429 47.8277L62.9425 47.8638L62.3341 48.538L62.7746 49.3901L62.4596 49.352L62.2771 48.9815C62.2284 48.8863 62.1881 48.7952 62.1453 48.6975L62.139 48.6966C62.0778 48.7818 62.0144 48.8573 61.9464 48.9416L61.6851 49.2584L61.3796 49.2215L62.0148 48.5095L61.5882 47.7006L61.8969 47.738Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M63.3538 47.9139L63.5317 48.2676C63.5783 48.3595 63.616 48.4438 63.6563 48.5348L63.6651 48.5357C63.7268 48.4505 63.7868 48.3779 63.8468 48.3024L64.1002 48.0037L64.3993 48.0398L63.791 48.7136L64.2315 49.5657L63.9168 49.5279L63.7343 49.1575C63.6852 49.0622 63.6454 48.9712 63.6026 48.8734L63.5963 48.8726C63.535 48.9577 63.4713 49.0333 63.4037 49.1176L63.1419 49.4344L62.8369 49.3974L63.4717 48.6855L63.0458 47.8766L63.3538 47.9139Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.8115 48.089L64.989 48.4427C65.0355 48.5346 65.0733 48.6189 65.1136 48.71L65.1228 48.7108C65.1845 48.6261 65.244 48.5531 65.3045 48.478L65.5579 48.1788L65.857 48.2153L65.2487 48.8891L65.6888 49.7412L65.3741 49.703L65.1916 49.333C65.1425 49.2373 65.1027 49.1463 65.0599 49.0485L65.0536 49.0477C64.9923 49.1333 64.929 49.2084 64.861 49.2927L64.5992 49.6095L64.2942 49.573L64.9294 48.8606L64.5027 48.0521L64.8115 48.089Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M66.2688 48.2646L66.4467 48.6187C66.4932 48.7105 66.5306 48.7949 66.5708 48.8859L66.5801 48.8868C66.6417 48.8016 66.7013 48.729 66.7617 48.6535L67.0147 48.3548L67.3143 48.3913L66.7055 49.0651L67.146 49.9167L66.8314 49.879L66.6493 49.5089C66.6002 49.4133 66.5595 49.3222 66.5171 49.2245L66.5108 49.2237C66.4496 49.3088 66.3858 49.3848 66.3183 49.4687L66.0569 49.7854L65.7515 49.7489L66.3862 49.0361L65.9604 48.2277L66.2688 48.2646Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M67.7256 48.4408L67.9034 48.7944C67.95 48.8863 67.9878 48.9707 68.028 49.0613L68.0373 49.0625C68.0985 48.9774 68.1581 48.9044 68.2189 48.8293L68.4719 48.5306L68.7711 48.5666L68.1627 49.2408L68.6032 50.0925L68.2882 50.0544L68.1061 49.6843C68.057 49.5887 68.0167 49.498 67.9743 49.3999L67.9676 49.3994C67.9064 49.4846 67.843 49.5601 67.7755 49.644L67.5137 49.9612L67.2083 49.9243L67.8434 49.2119L67.4172 48.4034L67.7256 48.4408Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M77.7762 36.4731C77.6012 37.9218 76.2859 38.9547 74.8368 38.7798L60.148 37.0101C58.6998 36.8356 57.6668 35.5199 57.8414 34.0712C58.0159 32.6221 59.3316 31.5896 60.7807 31.7641L75.4691 33.5342C76.9178 33.7087 77.9511 35.0244 77.7762 36.4731Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M72.5639 38.5056L71.1652 38.3374L71.797 33.0909L73.1962 33.2596L72.5639 38.5056Z",
					fill: "#FDE9EE"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M70.116 38.2109L68.0178 37.958L68.6497 32.7123L70.7478 32.9649L70.116 38.2109Z",
					fill: "#FDE9EE"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 44.6333,
			y: 29.4722,
			width: 5.75645,
			height: 5.75645,
			rx: .665,
			transform: "rotate(6.64392 44.6333 29.4722)",
			fill: "#FFC73D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.3179 32.6866L50.3004 30.6957L49.7552 35.2926C49.7111 35.6644 49.3688 35.9265 48.9983 35.8722L45.7218 35.3918L48.3179 32.6866Z",
			fill: "#FFEFC7"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 44.5084,
			y: 30.5439,
			width: 5.75645,
			height: .359778,
			transform: "rotate(6.64392 44.5084 30.5439)",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 44.3837,
			y: 31.6165,
			width: 5.75645,
			height: .359778,
			transform: "rotate(6.64392 44.3837 31.6165)",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.273 32.4314C48.181 33.2209 47.6265 33.8049 47.0344 33.736C46.4423 33.667 46.0368 32.9711 46.1288 32.1816C46.9329 32.2753 46.6088 32.2376 47.2009 32.3065C47.793 32.3755 47.6029 32.3533 48.273 32.4314Z",
			fill: "#D9D9D9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.9574 32.0325C47.8654 32.8219 47.4709 33.4246 47.0762 33.3787C46.6814 33.3327 46.436 32.6554 46.528 31.866C47.064 31.9284 46.8479 31.9032 47.2427 31.9492C47.6374 31.9952 47.5107 31.9804 47.9574 32.0325Z",
			fill: "#FFC73D"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter3_dddd_5649_532)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 50.9395,
				y: 69.2678,
				width: 49.9323,
				height: 9.92152,
				transform: "rotate(-45 50.9395 69.2678)",
				fill: "#EF476F"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 57.5667,
				y: 33.0781,
				width: 51.6379,
				height: 10.6203,
				transform: "rotate(45 57.5667 33.0781)",
				fill: "#EF476F"
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_ddddd_5649_532",
				x: 16.7642,
				y: 42.0171,
				width: 47.2121,
				height: 42.8185,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .3325 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .49875 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.29 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -.3325,
						dy: 1.6625
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .9975 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_532",
						result: "effect2_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -.9975,
						dy: 3.99
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.16375 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_532",
						result: "effect3_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1.995,
						dy: 6.9825
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.49625 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_532",
						result: "effect4_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -2.9925,
						dy: 10.9725
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.6625 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.960784 0 0 0 0 0.8 0 0 0 0 0.839216 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_5649_532",
						result: "effect5_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_5649_532",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_5649_532",
				x: 38.361,
				y: 26.1772,
				width: 44.215,
				height: 31.6034,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.73703 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .868513 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.980392 0 0 0 0 0.756863 0 0 0 0 0.807843 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_5649_532",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_ddddd_5649_532",
				x: 39.7655,
				y: 25.8447,
				width: 43.7335,
				height: 32.7844,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .16625 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.29 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: .3325,
						dy: .665
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .3325 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_532",
						result: "effect2_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: .665,
						dy: 1.33
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .3325 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.15 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_532",
						result: "effect3_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: .9975,
						dy: 1.995
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .49875 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.04 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_532",
						result: "effect4_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 1.6625,
						dy: 3.325
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .49875 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.764706 0 0 0 0 0.0745098 0 0 0 0 0.235294 0 0 0 0.01 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect4_dropShadow_5649_532",
						result: "effect5_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect5_dropShadow_5649_532",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_dddd_5649_532",
				x: 46.732,
				y: 32.4131,
				width: 50.6731,
				height: 56.6582,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: .665 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .665 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.18 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1.995 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .9975 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.16 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_5649_532",
						result: "effect2_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4.9875 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.49625 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.09 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_5649_532",
						result: "effect3_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 8.645 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.6625 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.745098 0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0.03 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_dropShadow_5649_532",
						result: "effect4_dropShadow_5649_532"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect4_dropShadow_5649_532",
						result: "shape"
					})
				]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgCreditCheckFailedSmall);
export { ForwardRef as ReactComponent };
